document.addEventListener('DOMContentLoaded', () => {

  const forms = document.querySelectorAll('.js-klaviyo-newsletter');

  if (!forms.length) return;

  forms.forEach((form) => {

    form.addEventListener('submit', async (e) => {

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const emailInput = form.querySelector('input[type="email"]');

      const successMessage = form.querySelector('.form-message--success');

      const errorMessage = form.querySelector('.form-message--error');

      if (successMessage) {
        successMessage.classList.add('hidden');
      }

      if (errorMessage) {
        errorMessage.classList.add('hidden');
      }

      if (!emailInput) return false;

      const email = emailInput.value.trim();

      if (!email) return false;

      try {

        const response = await fetch(
          'https://a.klaviyo.com/client/subscriptions/?company_id=XqTSUN',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'revision': '2024-02-15'
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email
                      }
                    }
                  }
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id: 'VjwcMn'
                    }
                  }
                }
              }
            })
          }
        );

        if (response.ok) {

          if (successMessage) {
            successMessage.classList.remove('hidden');
          }

          form.reset();

        } else {

          if (errorMessage) {
            errorMessage.classList.remove('hidden');
          }

        }

      } catch (error) {

        console.error(error);

        if (errorMessage) {
          errorMessage.classList.remove('hidden');
        }

      }

      return false;

    }, true);

  });

});